import React from 'react'
import { Form, Input } from 'antd'
import {
	COOKIES,
	COOKIE_NAME_FIELD,
	COOKIE_VALUE_FIELD,
	COOKIE_DOMAIN_FIELD,
	COOKIE_KEYS,
	SUCCESS
} from 'views/ScanSettings/NewScan/constants'
import DynamicForm from 'views/ScanSettings/NewScan/components/DynamicForm'
import { remoteValidation, extractResponse } from '../steps/validate';
import { apiClient } from 'utils/api-client';
import { getAuthHeader } from 'utils/auth';

const Cookies = ({ form, cookies, setValidationError }) => {
	const { getFieldDecorator } = form

	const onRemoteValidation = async (values) => {		
		try{
			let failureResponse = { origin: 'server', errors: [] }
			if (values) 
			{
				let response = await remoteValidation(values, COOKIE_KEYS, '/global/cookies/validate', failureResponse)
				response = extractResponse(response)
				failureResponse = response && !!response.length ? response : failureResponse
			}
			return !!failureResponse.errors.length ? failureResponse : SUCCESS;
		}
		catch(err){
			setValidationError(Array.isArray(err) ? err : [err.message]);
		}
	}

	const onEditItem = async (cookie) => {
		let data = {
			id : cookie.id,
			name : cookie[COOKIE_NAME_FIELD],
			value : cookie[COOKIE_VALUE_FIELD],
			domain : cookie[COOKIE_DOMAIN_FIELD]
		}
		try {
			let resp = await apiClient(`/global/cookies/${data.id}`, {method: "PUT", body: data, headers : getAuthHeader()})
		}
		catch(err) {
			console.log(err)
		}
	}

	const onDeleteItem = async (cookie) => {
		try {
			let resp = await apiClient(`/global/cookies/${cookie.id}`, {method: "DELETE", headers : getAuthHeader()})
			let index = cookies.findIndex((c) => c.id === cookie.id);
			if (index !==-1) {
				cookies.splice(index, 1);
				}		
		}
		catch(err) {
			console.log(err)
		}
	}

	return (
		<DynamicForm
			remoteValidation={async (values) => await onRemoteValidation(values)}
			form={form}
			dataList={cookies}
			dataType={COOKIES}
			dataTypeText="Cookies"
			formFields={[COOKIE_NAME_FIELD, COOKIE_VALUE_FIELD, COOKIE_DOMAIN_FIELD]}
			nameProp={COOKIE_NAME_FIELD}
			setValidationError={setValidationError}
			onEditItem={async (cookie) => await onEditItem(cookie)}
			onDeleteItem={async (cookie) => await onDeleteItem(cookie)}
		>
			<Form.Item label="NAME">
				{getFieldDecorator(COOKIE_NAME_FIELD, {
					validateTrigger: ['onChange', 'onBlur'],
					rules: [
						{
							required: true,
							whitespace: true,
							message: 'Cookie Name is required.'
						}
					]
				})(<Input placeholder="Name" />)}
			</Form.Item>
			<Form.Item label="VALUE">
				{getFieldDecorator(COOKIE_VALUE_FIELD, {
					validateTrigger: ['onChange', 'onBlur'],
					rules: [
						{
							required: true,
							whitespace: true,
							message: 'Cookie Value is Required.'
						}
					]
				})(<Input placeholder="Value" />)}
			</Form.Item>
			<Form.Item label="DOMAIN">
				{getFieldDecorator(COOKIE_DOMAIN_FIELD, {
					validateTrigger: ['onChange', 'onBlur'],
					rules: [
						{
							required: true,
							whitespace: true,
							message: 'Cookie Domain is Required.'
						}
					]
				})(<Input placeholder="Domain" />)}
			</Form.Item>
		</DynamicForm>
	)
}
export default Cookies
